import React, { useContext, useMemo } from "react";
import { FaArrowRight } from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import { isAdminUser } from "../utils/roleUtils";
import { decorateUiItems } from "../utils/uiConfig";
import { getUiIcon } from "../utils/uiIcons";
import "./HomeWidgets.css";

const HomeWidgets = ({ onNavigate }) => {
  const { user, uiConfig } = useContext(AuthContext);
  const firstName = user?.name?.split(" ")[0] || "there";
  const isAdmin = isAdminUser(user);

  const widgets = useMemo(
    () =>
      decorateUiItems(uiConfig?.dashboardWidgets || [], { isAdmin }).map(
        (widget) => ({
          ...widget,
          Icon: getUiIcon(widget.icon),
        })
      ),
    [isAdmin, uiConfig]
  );

  return (
    <div className="widgets-container">
      <header className="widgets-header">
        <div className="widgets-header-text">
          <p className="widgets-welcome">Welcome back, {firstName}</p>
          <h1 className="widgets-title">Dashboard</h1>
        </div>
        <p className="widgets-subtitle">Select a workspace to get started</p>
      </header>

      <div className="widgets-grid">
        {widgets.map((widget, index) => {
          const Icon = widget.Icon;
          return (
            <div
              key={widget.id}
              className="widget-card"
              onClick={() => onNavigate(widget.route)}
              style={{ animationDelay: `${0.05 + index * 0.05}s` }}
            >
              <div className="widget-card-top">
                <div className="widget-icon-wrapper">
                  <Icon className="widget-icon" />
                </div>
                <FaArrowRight className="widget-arrow" />
              </div>
              <div className="widget-content">
                <h3>{widget.label}</h3>
                <p>{widget.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomeWidgets;
